/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

import { FaHandPointer } from '@react-icons/all-files/fa/FaHandPointer';
import { FaBaseballBall } from '@react-icons/all-files/fa/FaBaseballBall';

import { BiFootball } from '@react-icons/all-files/bi/BiFootball';
import { BsLaptop } from '@react-icons/all-files/bs/BsLaptop';
import { ImPencil2 } from '@react-icons/all-files/im/ImPencil2';
import { GiTennisBall } from '@react-icons/all-files/gi/GiTennisBall';
import { GiDart } from '@react-icons/all-files/gi/GiDart';
import { imagePrettyUrl } from 'gatsby-core-theme/src/helpers/getters';
import Button from 'gatsby-core-theme/src/components/atoms/button';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import styles from './registration-step.module.scss';

/* eslint-disable react/jsx-wrap-multilines */

const RegistrationStep = ({
  title = 'steps',
  imagePath = '',
  color = 'soccer',
  icon = 'soccer',
  description = 'Go to provider site',
  info = '',
  link = '',
  arrowPath = '',
  className = 'default',
  provider,
  hasTNCModal = false,
  tncText = '',
  isGamebox = false,
  gtmClass = '',
}) => {
  const TnCModal = hasTNCModal ? (
    loadable(() => import('gatsby-core-theme/src/hooks/modal'))
  ) : (
    <></>
  );

  const getIcon = (i) => {
    switch (i) {
      case 'pencil':
        return <ImPencil2 className={styles.pencil} />;
      case 'hand':
        return <FaHandPointer className={styles.hand} />;
      case 'soccer':
      case 'handball':
        return <BiFootball className={styles.soccer} />;
      case 'tennis':
        return <GiTennisBall className={styles.tennis} />;
      case 'darts':
        return <GiDart className={styles.soccer} />;
      case 'cricket':
        return <FaBaseballBall className={styles.soccer} />;
      default:
        return false;
    }
  };

  const getImageWrap = (iw) => {
    switch (iw) {
      case 'pencil':
        return <span className={styles.lines} />;
      case 'soccer':
      case 'handball':
      case 'tennis':
      case 'darts':
      case 'cricket':
        return <span className={styles.carouselArrow} />;
      default:
        return imagePath ? (
          <LazyImage src={imagePrettyUrl(imagePath)} alt="provider logo" width={80} height={40} />
        ) : null;
    }
  };

  return (
    <>
      <div
        className={`${styles.gridItem} ${styles[color]} ${styles[className]} ${
          isGamebox && styles.gameboxTile
        }`}
      >
        <span className={`${styles.stepsTitle} h4`}>{title}</span>
      </div>
      <div
        className={`${styles.gridItem} ${styles[color]} ${styles[className]} ${
          isGamebox && styles.gameboxImage
        }`}
      >
        {link !== '' ? (
          <Button
            to={link}
            isInternalLink={false}
            targetBlank={false}
            noStyle
            btnText={
              <div className={styles.iconWrapper}>
                <BsLaptop className={styles.laptop} />
                <div className={`${styles.imageWrapper} ${styles[icon]}`}>{getImageWrap(icon)}</div>
                {getIcon(icon)}
              </div>
            }
            gtmClass={`${gtmClass} registration-step-gtm`}
          />
        ) : (
          <div className={styles.iconWrapper}>
            <BsLaptop className={styles.laptop} />
            <div className={`${styles.imageWrapper} ${styles[icon]}`}>{getImageWrap(icon)}</div>
            {getIcon(icon)}
          </div>
        )}
        {arrowPath && (
          <LazyImage
            className={styles.nextArrow}
            src={arrowPath}
            alt="arrow"
            width={56}
            height={29}
          />
        )}
      </div>
      <div
        className={`${styles.gridItem} ${styles[color]} ${styles[className]} ${
          styles.descriptionGridItem
        } ${isGamebox && styles.gameboxDescription}`}
      >
        <p>{description}</p>
        {info && <small>{info}</small>}
        {hasTNCModal && provider?.sports_data[color]?.disclaimer && (
          <TnCModal content={provider?.sports_data[color]?.disclaimer}>
            <span className={styles.modalTrigger}>{tncText}</span>
          </TnCModal>
        )}
      </div>
    </>
  );
};

RegistrationStep.propTypes = {
  title: PropTypes.string,
  isGamebox: PropTypes.bool,
  imagePath: PropTypes.string,
  arrowPath: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  info: PropTypes.string,
  link: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  provider: PropTypes.shape({
    sports_data: PropTypes.shape({}),
  }),
  hasTNCModal: PropTypes.bool,
  tncText: PropTypes.string,
  gtmClass: PropTypes.string,
};

export default RegistrationStep;
